import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PageUrls } from 'src/app/helpers/page-urls';
import { AppUtils } from 'src/app/helpers/app.utils';
import { UserService } from 'src/app/admin/services/user.service';
import { TableModel } from 'src/app/models/table.model';
import { Router } from '@angular/router';
import { PagedEditorDetailModel } from 'src/app/admin/models/paged.editor.detail.model';

@Component({
    selector: 'app-user-editor',
    templateUrl: './user.editor.component.html',
    styleUrls: ['./user.editor.component.scss']
})
export class UserEditorComponent implements OnInit {

    tableModel = new TableModel();
    totalRecords = 1;
    subscriptions = new Array<Subscription>();
    pagedEditorDetail = new PagedEditorDetailModel();
    isModelLoaded = false;

    constructor(private router: Router,
        private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private userService: UserService) {
        this.tableModel.orderBy = 'FirstName';
        this.tableModel.orderByDirection = 'asc';
    }

    get urls() {
        return PageUrls;
    }

    ngOnInit() {
        this.initSubscribers();
        this.getEditors();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getEditors());
        this.subscriptions.push(subscription);
    }

    getEditors() {
        this.isModelLoaded = false;
        this.ngxSpinner.show();
        this.userService.listEditor(this.tableModel)
            .subscribe(data => {
                this.pagedEditorDetail = data;
                this.totalRecords = data.totalCount;
                this.ngxSpinner.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    deleteEditor(id: number) {
        if (!confirm('Are you sure you want to delete this editor?')) {
            return;
        }
        this.ngxSpinner.show();
        this.userService.deleteEditor(id)
            .subscribe(() => {
                this.toastr.success('Editor has been deleted successfully');
                this.ngxSpinner.hide();
                this.getEditors();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    openEditEditor(id: number) {
        this.router.navigateByUrl(`${PageUrls.Admin.UserEditEditor}?editorId=${id}`);
    }

    resetTableModel() {
        this.tableModel.page = 1;
    }
}
